import React from 'react'
import Reflux from 'reflux'
import Store from '../store/store'

import {Redirect, Route} from 'react-router-dom'
import Login from './login/login'
import Signup from './signup/signup'
import Footer from './common/footer/footer'
import Header from './common/header/header'
import PrivacyPolicy from './pages/privacypolicy'
import TermsAndConditions from './pages/termsandconditions'
import PasswordReset from './pages/passwordreset'
import Company from './company/company'
import Onlineszamla from "./company/onlineszamla";
import Bank from './bank/bank'
import TakarekBankReplacer from "./bank/TakarekBankReplacer";
import BankTestInput from "./bank/BankTestInput";
import BankRules from './bank/bankrules'
import Cashregister from './cashregister/cashregister'
import Supplier from './supplier/supplier'
import Customer from "./customer/customer";
import CustomerRules from './customer/CustomerRules'
import Mixed from './Mixed/Mixed'
import User from '../helpers/user'
import ScrollUpButton from "react-scroll-up-button"
import Profile from './profile/profile'
import Payment from './payment/payment'
import PaymentFinish from "./payment/paymentfinish";
import ForgotPassword from './forgottpassword/forgottpassword'
import ConfirmRegistration from './signup/confirmregistration'

class AppComponent extends Reflux.Component {

    constructor() {
        super()
        this.state = {
            isGuest: User.isGuest(),
        }
        this.store = Store
    }

    componentDidMount = () => {
        this.setState({
            isGuest: User.isGuest(),
        })
    }

    render() {
        return (
            <div className="App">

                <Header/>

                <Route exact
                       path="/"
                       render={() => this.state.isGuest ? <Redirect to="/login"/> : <Company/>}
                />

                <Route exact
                       path="/start/customer/:id"
                       location={this.props.location}
                       render={(location) => this.state.isGuest ? <Redirect to="/login"/> : <Customer location={location}/>}
                />

                <Route exact
                       path="/start/bank/:id"
                       location={this.props.location}
                       render={(location) => (this.state.isGuest ? (<Redirect to="/login"/>) : (<Bank location={location}/>))}
                />

                <Route exact
                       path="/start/supplier/:id"
                       location={this.props.location}
                       render={(location) => (this.state.isGuest ? (<Redirect to="/login"/>) : (<Supplier location={location}/>))}
                />

                <Route exact
                       path="/start/cashregister/:id"
                       location={this.props.location}
                       render={(location) => (this.state.isGuest ? (<Redirect to="/login"/>) : (<Cashregister location={location}/>))}
                />

                <Route exact
                       path="/start/mixed/:id"
                       location={this.props.location}
                       render={(location) => (this.state.isGuest ? (<Redirect to="/login"/>) : (<Mixed location={location}/>))}
                />

                <Route exact
                       path="/confirm-registration/:token"
                       location={this.props.location}
                       render={(location) => <ConfirmRegistration location={location}/>}
                />

                <Route exact
                       path="/customer/rules/:id"
                       location={this.props.location}
                       render={(location) => (this.state.isGuest ? (<Redirect to="/login"/>) : (<CustomerRules location={location}/>))}
                />

                <Route exact
                       path="/bank/rules/:id"
                       location={this.props.location}
                       render={(location) => (this.state.isGuest ? (<Redirect to="/login"/>) : (<BankRules location={location}/>))}
                />

                <Route exact
                       path="/bank/takarek-bank-replacer"
                       location={this.props.location}
                       render={location => (this.state.isGuest ? <Redirect to="/login"/> : <TakarekBankReplacer location={location}/>)}
                />

                <Route exact
                       path="/bank/test-input"
                       location={this.props.location}
                       render={location => (this.state.isGuest ? <Redirect to="/login"/> : <BankTestInput location={location}/>)}
                />

                <Route exact
                       path="/companies-list"
                       render={() => (this.state.isGuest ? (<Redirect to="/login"/>) : (<Company/>))}
                />

                <Route exact
                       path="/company/onlineszamla/:id"
                       location={this.props.location}
                       render={(location) => (this.state.isGuest ? (<Redirect to="/login"/>) : (<Onlineszamla location={location}/>))}/>

                <Route exact
                       path="/login"
                       render={() => (!this.state.isGuest ? (<Redirect to="/"/>) : (<Login/>))}
                />

                <Route exact
                       path="/signup"
                       render={() => (!this.state.isGuest ? (<Redirect to="/"/>) : (<Signup/>))}
                />

                <Route exact
                       path="/request-password-reset"
                       render={() => (!this.state.isGuest ? (<Redirect to="/"/>) : (<PasswordReset/>))}
                />

                <Route exact
                       path="/payment-start"
                       render={() => (this.state.isGuest ? (<Redirect to="/"/>) : (<Payment/>))}
                />

                <Route exact
                       path="/payment-finish"
                       location={this.props.location}
                       render={(location) => (this.state.isGuest ? (<Redirect to="/"/>) : (<PaymentFinish location={location}/>))}
                />

                <Route exact
                       path="/terms-and-conditions"
                       render={() => <TermsAndConditions/>}
                />

                <Route exact
                       path="/privacy-policy"
                       render={() => <PrivacyPolicy/>}
                />

                <Route exact
                       path="/forgott-password/:token"
                       location={this.props.location}
                       render={(location) => (this.state.isGuest ? (<ForgotPassword location={location}/>) : (<Redirect to="/"/>))}
                />

                <Route exact path="/user-profile"
                       location={this.props.location}
                       render={(location) => (this.state.isGuest ? (<Redirect to="/login"/>) : (<Profile location={location}/>))}/>

                <Footer/>

                <ScrollUpButton/>

            </div>
        )
    }
}

export default AppComponent



// WEBPACK FOOTER //
// ./src/components/App.js